export default __webpack_public_path__ + "static/media/bloodwarrior.59a631db.png";